import { useEffect } from "react";
import TagManager from "react-gtm-module";
import { gtmId } from "@util/constant";

type UseInitGTMOptions = {
  enabled?: boolean;
};

export const useInitGTM = ({ enabled = true }: UseInitGTMOptions = {}) => {
  useEffect(() => {
    if (!enabled) return;
    if (typeof window === "undefined" || !gtmId) return;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((window as any).gtmInitialized) return; // prevent double init

    TagManager.initialize({ gtmId: gtmId });
    (window as any).gtmInitialized = true; // eslint-disable-line @typescript-eslint/no-explicit-any
  }, [enabled]);
};
